export enum TechnicianStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}
